import React from 'react';
import PropTypes from 'prop-types';

function IconTombstone({ color = '#B3B3B3', size = 20, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 13.3333V10M10 6.66626H10.0083M18.3341 9.99959C18.3341 14.602 14.6032 18.3329 10.0008 18.3329C5.39844 18.3329 1.66748 14.602 1.66748 9.99959C1.66748 5.39722 5.39844 1.66626 10.0008 1.66626C14.6032 1.66626 18.3341 5.39722 18.3341 9.99959Z" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconTombstone.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconTombstone;
